import React from 'react';
import { useTranslation } from 'next-i18next';
import Keyword from 'components/keyword';
import { useThemeContext } from 'contexts/theme';
import { ThemeNames } from 'types/themes';
import { Namespaces, LOCALE_INTERNAL_LINKS_PATHS } from 'types/locales';

interface Props {
  slug: string;
  areaName: string;
  latitude: number;
  longitude: number;
  subLocation?: string;
}

export default function KeywordsList({ slug, areaName, latitude, longitude, subLocation }: Props) {
  const { t, ready } = useTranslation(Namespaces.INTERNAL_LINKS);
  const { themeName, theme } = useThemeContext();
  const isExpTheme = themeName !== ThemeNames.ZOOCASA;
  const formattedKeywords = theme.keywords.map(keyword => {
    const translatedLabel = t(keyword.label, { defaultValue: keyword.label });

    if (keyword.type === 'area') {
      const areaPageLink = `${slug}-real-estate${subLocation}${keyword.link}`;
      return {
        label: translatedLabel,
        link: areaPageLink,
      };
    }
    else if (keyword.type === 'search') {
      const searchPageLink = `${keyword.link}&latitude=${latitude}&longitude=${longitude}&area-name=${areaName}&slug=${slug}`;
      return {
        label: translatedLabel,
        link: searchPageLink,
      };
    }
    else if (isExpTheme && keyword.label === LOCALE_INTERNAL_LINKS_PATHS.FIND_AN_AGENT) {
      return {
        label: translatedLabel,
        link: '/agents-search',
      };
    }
    else {
      return {
        label: translatedLabel,
        link: keyword.link,
      };
    }
  });

  return <>{ready && formattedKeywords.map(keyword => <Keyword key={keyword.label} keyword={keyword} className={isExpTheme ? 'exp-keyword' : ''} />)}</>;
}
